export default {
  performSimpleSearch(payload) {
    let url = `/api/search?`;
    let params = { ...payload };

    if (payload.moduleInstances) {
      params.moduleInstances = payload.moduleInstances.join(',');
    }

    const queryString = new URLSearchParams(params).toString();

    return fetch(url + queryString).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }
      return response.json();
    });
  },
};
